import React, { forwardRef, useState, useEffect } from "react";
import { useAppSelector, useAppDispatch } from "../../store/hooks";
import {
  PageLink,
  Label,
  SecondaryButton,
} from "../../components/StyledComp/StyledComp";
import InputField from "../StyledComp/InputField";
import InputFieldLargeDisabled from "../StyledComp/InputFieldLargeDisabled";
import IMember from "../../store/memberInterfaceStruct";
import { useDispatch, useSelector } from "react-redux";
import { updateCurrentMember } from "../../store/currentMemberSlice";
import { Button } from "../StyledComp/StyledComp";
import CalendarImg from "../../Images/calendar.png";
import { screenConfig } from "../../config/screenConfig";
import { changeCurrentMemberMenu } from "../../store/screenSlice";
import { SaveSearchString } from "../../store/currentMemberSlice";
import {
  assignMemberPersonal,
  editMemberPersonal,
} from "../../store/editMemberapiSlice";
import { RootState } from "../../store/store";
import MemberServices from "../../services/MemberServices";
// import Select from "react-select";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import * as routeConfig from "../../config/routes";
import { useNavigate } from "react-router-dom";
import { executeSearchBody } from "../../store/searchMemberApiSlice";
import AlertWithModal from "../utilityComponents/AlertWithModal";

interface ISaveSearchList {
  Id: number;
  QueryType: string | null;
  SearchName: string | null;
  SearchParameters: string | null;
  CreatedBy: string | null;
  CreatedAt: string | null;
  UpdatedAt: string | null;
}

// let savedSearchList:  ISaveSearchList[] = [];

const FMSavedSearchList: React.FC = () => {
  const dispatch = useDispatch();

  const [savedSearchList, setSavedSearchList] = useState<ISaveSearchList[]>([]);
  const [searchId, setSearchId] = useState<number>();
  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");
  const navigate = useNavigate();

  useEffect(() => {
    const getSavedSearchList = async () => {
      console.log("getSavedSearchList called");
      const response = await MemberServices.getSavedSearchList();
      console.log("response...", response.data.data);
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        console.log("Success");
        console.log("response1...", response.data.data);
        setSavedSearchList(response.data.data);
      } else {
      }
    };

    getSavedSearchList();
  }, []);

  console.log("savedSearchList:", savedSearchList);

  const closeMemberEditPersonalInfoScreen = () => {
    navigate(routeConfig.FIND_MEMBER_URL, { replace: false });
    // dispatch(changeCurrentMemberMenu(screenConfig.memberFindScreen));
  };

  const executeSearch = async (searchId: any) => {
    console.log("SearchParameters", JSON.parse(searchId));
    dispatch(executeSearchBody(JSON.parse(searchId)));
    // setSearchId(searchId);
    // dispatch(SaveSearchString(searchId));
    navigate(routeConfig.MEMBERS_URL, { replace: false });
    // dispatch(changeCurrentMemberMenu(screenConfig.findMemberListSavedQuery));
  };

  

  const currentMember = useAppSelector((state) => state.currentMember);
  console.log("currentMember in saved search:", currentMember);
  return (
    <div className="overlay-fullscreen overlay-EditMemberwrapper">
      <div className="section-box " style={{ height: "90%" }}>
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">Saved Search</h1>
          <PageLink onClick={closeMemberEditPersonalInfoScreen}>
            Cancel
          </PageLink>
        </div>
        <div className="verticalScroll" style={{ height: "80%" }}>
          {typeof savedSearchList != "undefined" ? (
            savedSearchList?.map((savedSearch: any) => (
              <div className="section-box ">
                <div className="horizontal-wrapper-spacebetween">
                  <h5>{savedSearch.SearchName}</h5>
                  <div className="small-button-div">
                    <Button
                      type="submit"
                      onClick={() =>
                        executeSearch(savedSearch.SearchParameters)
                      }
                    >
                      Execute
                    </Button>
                  </div>
                </div>
                <span>{savedSearch.SearchParameters}</span>
              </div>
            ))
          ) : (
            <div>Loading</div>
          )}
        </div>
        {/* <div className="button-wrapper">
          <div className="submit-button-div ">
            <Button type="submit" onClick={closeMemberEditPersonalInfoScreen}>
              Close
            </Button>
          </div>
        </div> */}
      </div>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default FMSavedSearchList;
